import React from "react";
import * as Styles from "./styles";

interface Props {
  open: boolean;
}

export default function LogoutOverlay({ open }: Props): JSX.Element | null {
  if (!open) return null;

  return (
    <Styles.Backdrop role="status" aria-live="polite">
      <Styles.Card>
        <Styles.Spinner />
        <Styles.Title>Saindo do Sell.it</Styles.Title>
        <Styles.Description>
          Encerrando sua sessão, por favor aguarde...
        </Styles.Description>
      </Styles.Card>
    </Styles.Backdrop>
  );
}
